import React from "react";
import { useNavigate } from "react-router-dom";
import { signOut as firebaseSignOut } from "../config/firebaseConfig";
import "../styles/LogoutButton.css"; // Import the CSS file
import { useUnsavedChanges } from "../contexts/UnsavedChangesContext";

const LogoutButton = () => {
  const navigate = useNavigate(); // Hook to get navigate function
  const { handleProtectedNavigation } = useUnsavedChanges();

  const performLogout = async () => {
    try {
      await firebaseSignOut(); // Call signOut function from firebaseConfig
      navigate("/login"); // Redirect to login page
    } catch (error) {
      console.error("Error signing out: ", error);
    }
  };

  const handleLogout = () => {
    handleProtectedNavigation(performLogout);
  };

  return (
    <button onClick={handleLogout} className="logout-button">
      Log Out
    </button>
  );
};

export default LogoutButton;
